import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen grid place-items-center bg-gray-800 text-white" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl text-center mb-5" }, "404", -1)
const _hoisted_3 = { class: "flex items-center space-x-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Go back", -1)

import { Icon } from '@iconify/vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createVNode(_component_BaseButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Icon), { icon: "bi:chevron-left" }),
            _hoisted_4
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})